import React, { useEffect } from 'react';
import styled from 'styled-components';
import { bool, func, string } from 'prop-types';
import AboutLimits from '../images/about-limits.svg';
import Close from '../images/close.svg';
import { aboutLimitsModalView } from '../services/tracking';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: ${({ open }) => ((open) ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  position: relative;
  background-color: #ffffff;
  max-width: 350px;
  box-sizing: border-box;
  padding: 64px 27px 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px 8px 0px 0px;
  @media(min-width: 1000px) {
    max-width: 666px;
    padding: 72px 36px 56px;
    border-radius: 8px;
  }
`;

const CloseIcon = styled.img`
  position: absolute;
  top: 28px;
  right: 32px
  @media(min-width: 1000px) {
    top: 37px;
    right: 48px
    cursor: pointer;
  }
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  line-height: 150%;
  color: #4A4A4A;
  margin-bottom: 8px;
  @media(min-width: 1000px) {
    font-size: 36px;
    line-height: 44px;
    margin-bottom: 24px;
  }
`;

const Text = styled.div`
  font-size: 14px;
  line-height: 140%;
  color: #4A4A4A;
  text-align: center;
  @media(min-width: 1000px) {
    font-size: 16px;
    line-height: 150%;
  }
`;

const Image = styled.img`
  margin: 38px 13px 32px;
  max-width: 324px
  @media(min-width: 1000px) {
    max-width: 440px
    margin: 46px 0;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;background: #F28000;
  border-radius: 100px;
  border: none;
  color: #FFF;
  padding: 12px 24px;
  height: 40px;
  width: 286px
  font-size: 16px;
  line-height: 24px;
  @media(min-width: 1000px) {
    height: 48px;
    width: 206px
    cursor: pointer;
  }
`;

const AboutLimitsnModal = ({
  funnelId, pointOfSale, open, onClose,
}) => {
  useEffect(() => {
    if (open) {
      aboutLimitsModalView({ pointOfSale, funnelId });
    }
  }, [open]);
  return (
    <Overlay open={open} onClick={onClose}>
      <Container onClick={event => event.stopPropagation()}>
        <CloseIcon alt="close icon" src={Close} onClick={onClose} />
        <Title>Como funciona o limite de inserção de anúncio em autos e em imóveis</Title>
        <Text>
          Temos limites de inserções gratuitas por categoria e, se precisar criar mais publicações, você pode comprar um Anúncio Extra ou contratar um Plano Profissional.
        </Text>
        <Image alt="About limits" src={AboutLimits} />
        <Button onClick={onClose}>Ok, entendi</Button>
      </Container>
    </Overlay>
  );
};
AboutLimitsnModal.propTypes = {
  funnelId: string.isRequired,
  pointOfSale: string.isRequired,
  open: bool.isRequired,
  onClose: func.isRequired,
};

export default AboutLimitsnModal;

